<template>
  <b-form-group>
    <b-icon icon="arrow-up-right-square" class="pdf-icon"></b-icon>
    <a class="pdf-link" :href="downloadLink" target="_blank">{{fileNameWithoutExtension}} als PDF</a>
  </b-form-group>
</template>

<script>
  import { errorHandler } from '@/helpers/formHelper.js'

  export default {
    data: () => ({
      hasUnknownError: false,
      unknownErrorMessage: '',
      downloadLink: '',
      fileNameWithoutExtension: ''
    }),
    created () {
      this.getGuidance()
    },
    methods: {
      async getGuidance () {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('file/GET_GUIDANCE', {
          applicationType: this.applicationType,
          communityId: this.communityId
        }).then(res => {
          const { errors, data } = res

          if (errors) {
            return errorHandler(this, errors)
          }

          const { downloadLink, fileNameWithoutExtension } = data.gesuchsArtWegleitung
          this.downloadLink = downloadLink
          this.fileNameWithoutExtension = fileNameWithoutExtension
        }).catch(err => {
          this.hasUnknownError = true
          console.error(err)
        })
      }
    },
    props: {
      applicationType: {
        type: String,
        required: true
      },
      communityId: {
        type: Number,
        required: true
      }
    },
    watch: {
      applicationType (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.getGuidance()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .pdf-icon{
    margin-right: 0.5rem;
    font-size: 18px;
    color: $primary;
  }
  .pdf-link{
    color: $black-80;
    font-size: 14px;
  }
</style>
